import React from "react";
import BigNumber from "bignumber.js";

export const PAYMENT_PRICE_TYPE_TOTAL_NET_PRICE = "net_total"; // 1
export const PAYMENT_PRICE_TYPE_TOTAL_GROSS_PRICE = "gross_total"; // 2
export const PAYMENT_PRICE_TYPE_UNIT_NET_PRICE = "net"; // 3
export const PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE = "gross"; // 4

export const PAYMENT_PRICE_TYPES = [
    PAYMENT_PRICE_TYPE_TOTAL_NET_PRICE,
    PAYMENT_PRICE_TYPE_TOTAL_GROSS_PRICE,
    PAYMENT_PRICE_TYPE_UNIT_NET_PRICE,
    PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE
];

export const PriceView = (field) => {
    return [...PAYMENT_PRICE_TYPES.map((type) => field + "_" + type), field + "_" + "vatrate", field + "_" + "full_vatrate"];
}

export class Price {

    data = {};

    type = PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE;

    sets = {};

    constructor(price, type = PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE) {
        this.data = price;
        this.setType(type);
    }

    setType = (type) => {
        this.type = type;
        let full_vatrate = 1 + parseFloat(this.data.vatrate);
        let qty = parseFloat(this.data.qty);
        this.gets = {};
        this.sets = {};
        this.sets.net = (price) => {
            this.data.net = parseFloat(price);
            this.data.gross = new BigNumber(this.data.net).multipliedBy(full_vatrate).toNumber();

            this.data.gross_total = new BigNumber(this.data.gross).multipliedBy(qty).toNumber();
            this.data.net_total = new BigNumber(this.data.gross_total).dividedBy(full_vatrate).toNumber();
        }
        this.sets.net_total = (price) => {
            this.data.net_total = parseFloat(price);
            this.data.net = new BigNumber(this.data.net_total).dividedBy(qty).toNumber();

            this.data.gross_total = new BigNumber(this.data.net_total).multipliedBy(full_vatrate).toNumber();
            this.data.gross = new BigNumber(this.data.net).multipliedBy(full_vatrate).toNumber();
        }
        this.sets.gross = (price) => {
            this.data.gross = parseFloat(price);
            this.data.net = new BigNumber(this.data.gross).dividedBy(full_vatrate).toNumber();

            this.data.gross_total = new BigNumber(this.data.gross).multipliedBy(qty).toNumber();
            this.data.net_total = new BigNumber(this.data.gross_total).dividedBy(full_vatrate).toNumber();
        }
        this.sets.gross_total = (price) => {
            this.data.gross = new BigNumber(parseFloat(price)).dividedBy(qty).toNumber();
            this.data.net = new BigNumber(this.data.gross).dividedBy(full_vatrate).toNumber();

            this.data.gross_total = this.data.gross;
            this.data.net_total = new BigNumber(this.data.gross_total).dividedBy(full_vatrate).toNumber();
        }
        this.sets.vatrate = (vatrate) => {
            this.data.vatrate = vatrate;
            full_vatrate = 1 + parseFloat(this.data.vatrate);
            if (this.type.indexOf("net") !== -1) {
                this.setPrice(this.getPrice());
            } else {
                this.setPrice(this.getPrice());
            }
        }
        this.sets.qty = (_qty) => {
            this.data.qty = _qty;
            qty = _qty;
            if (this.type.indexOf("net") !== -1) {
                this.setPrice(this.getPrice());
            } else {
                this.setPrice(this.getPrice());
            }
        }
        switch (this.type) {
            // TODO mindehova mehetne még a vatamount de az nem érdekes szerintem front-enden egyenlőre
            case PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE:
                this.gets.gross = (price = null) => {
                    if (price !== null && price === undefined) return parseFloat(price);
                    return parseFloat(this.data.gross || 0);
                }
                this.gets.gross_total = (price = null) => {
                    return new BigNumber(this.gets.gross(price !== null && price === undefined ? (new BigNumber(parseFloat(price)).dividedBy(qty).toNumber()) : price)).multipliedBy(qty).toNumber();
                }
                break;
            case PAYMENT_PRICE_TYPE_TOTAL_GROSS_PRICE:
                this.gets.gross_total = (price = null) => {
                    if (price !== null && price === undefined) return parseFloat(price);
                    return this.data.gross_total || 0;
                }
                this.gets.gross = (price = null) => {
                    return new BigNumber(this.gets.gross_total(price !== null && price === undefined ? (new BigNumber(parseFloat(price)).multipliedBy(qty).toNumber()) : price)).dividedBy(qty).toNumber();
                }
                break;
            case PAYMENT_PRICE_TYPE_TOTAL_NET_PRICE:
                this.gets.net_total = (price = null) => {
                    if (price !== null && price === undefined) return parseFloat(price);
                    return this.data.net_total || 0;
                }
                this.gets.gross_total = (price = null) => {
                    return new BigNumber(this.gets.net_total(price !== null && price === undefined ? (new BigNumber(parseFloat(price)).multipliedBy(qty).toNumber()) : price)).dividedBy(qty).toNumber();
                }
                break;
            case PAYMENT_PRICE_TYPE_UNIT_NET_PRICE:
                this.gets.net = (price = null) => {
                    if (price !== null && price === undefined) return parseFloat(price);
                    return this.data.net || 0;
                }
                this.gets.net_total = (price = null) => {
                    return new BigNumber(this.gets.net(price !== null && price === undefined ? (new BigNumber(parseFloat(price)).dividedBy(qty).toNumber()) : price)).multipliedBy(qty).toNumber();
                }
                break;
        }
        switch (this.type) {
            case PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE:
            case PAYMENT_PRICE_TYPE_TOTAL_GROSS_PRICE:
                this.gets.net = (price = null) => {
                    return new BigNumber(this.gets.gross(price !== null && price === undefined ? (new BigNumber(parseFloat(price)).multipliedBy(full_vatrate).toNumber()) : price)).dividedBy(full_vatrate).toNumber();
                }
                this.gets.net_total = (price = null) => {
                    return new BigNumber(this.gets.net(price !== null && price === undefined ? (new BigNumber(parseFloat(price)).dividedBy(qty).toNumber()) : price)).multipliedBy(qty).toNumber();
                }
                break;
            case PAYMENT_PRICE_TYPE_TOTAL_NET_PRICE:
            case PAYMENT_PRICE_TYPE_UNIT_NET_PRICE:
                this.gets.gross = (price = null) => {
                    return new BigNumber(this.gets.net(price !== null && price === undefined ? (new BigNumber(parseFloat(price)).dividedBy(full_vatrate).toNumber()) : price)).multipliedBy(full_vatrate).toNumber();
                }
                this.gets.gross_total = (price = null) => {
                    return new BigNumber(this.gets.gross(price !== null && price === undefined ? (new BigNumber(parseFloat(price)).dividedBy(qty).toNumber()) : price)).multipliedBy(qty).toNumber();
                }
                break;
        }
    }

    getPrice = (type = null) => {
        return this.gets[type || this.type]();
    }

    setPrice = (price, type = null) => {
        this.sets[type || this.type](price);
    }

    setVatrate = (vatrate) => {
        this.sets.vatrate(vatrate);
    }

    setQty = (qty) => {
        this.sets.qty(qty);
    }

    boundTo = (item, space = "") => {
        Object.keys(this.gets).map((key) => {
            item[(space ? (space + "_") + key : key) ] = this.gets[key]();
        });
        if (space) {
            item[space] = this.getPrice();
        }
    }
}

export const calculateItemPrice = (type, field, item, oldItem, priceType = PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE) => {
    const priceData = {};
    PAYMENT_PRICE_TYPES.map((priceType) => {
        priceData[priceType] = item[type + "_" + priceType];
    });
    priceData.qty = oldItem.qty === undefined ? oldItem.pickedqty : oldItem.qty;
    priceData.vatrate = oldItem.vat.rate;
    // TODO EZT A SZEKCIÓT MAJD SZÉPEN, EZ KICSESZETT RONDA ÉS HÜLYÉN VAN MEGOLDVA
    if (field === "vat" || type === "saleprice" || field === "listprice") {
        const price = new Price(priceData, PAYMENT_PRICE_TYPE_UNIT_NET_PRICE);
        price.setVatrate(item.vat.rate);
        PAYMENT_PRICE_TYPES.map((priceType) => {
            priceData[priceType] = price.gets[priceType]();
        });
    }
    const price = new Price(priceData, priceType);
    if (field === "qty" || field === "pickedqty") {
        price.setQty(item.qty === undefined ? item.pickedqty : item.qty);
    }
    // TODO EZT A SZEKCIÓT MAJD SZÉPEN, EZ KICSESZETT RONDA ÉS HÜLYÉN VAN MEGOLDVA
    PAYMENT_PRICE_TYPES.map((priceType) => {
        if (field === type + "_" + priceType) {
            price.setPrice(item[field], priceType);
            item[type] = price.getPrice(/*PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE*/);
        }
    });
    return price;
};